import { render, staticRenderFns } from "./type-opdracht.vue?vue&type=template&id=071d0bb2"
import script from "./type-opdracht.vue?vue&type=script&lang=js"
export * from "./type-opdracht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports